import {typography} from 'material-ui/styles';
import { injectGlobal } from 'styled-components';
import neoSans from 'Content/Assets/fonts/Neo_Sans.ttf';

/* eslint no-unused-expressions: 0 */
injectGlobal`
  @font-face {
    font-family: 'NeoSans';
    src: url(${neoSans}) format('truetype');
    font-weight: normal;
    font-style: normal;
  }
`;

const styles = {
  navigation: {
    fontSize: 22,
    fontWeight: typography.fontWeightLight,
    color: '#636363',
    paddingBottom: 15,
    display: 'block'
  },
  title: {
    fontSize: 24,
    fontWeight: typography.fontWeightLight,
    marginBottom: 20
  },
  paper: {
    fontFamily: "'NeoSans', 'Calibri Light', 'Roboto'",
    padding: 0
  },
  card: {
    fontFamily: "'NeoSans',  'Calibri Light', 'Roboto'"
  },
  clear: {
    clear: 'both'
  },
  h2:{
    fontSize: 30
  }
};

export default styles;



// WEBPACK FOOTER //
// ./src/layouts/material-admin/globalStyles.js